/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { createSelector, createSlice } from '@reduxjs/toolkit';
import { ThunkStatus } from '../../enums/ThunkStatus';
import { fetchSubmissionRows } from './submissions.thunk';

/* Initial state */
const initialState = {
  submissionsData: {
    status: ThunkStatus.IDLE,
    rowItems: [],
  },
};

/* Slice */
export const submissionsSlice = createSlice({
  name: 'submissions',
  initialState,
  reducers: {
    submissionUpdated(state, action) {
      const updatedSubmission = action.payload;

      state.submissionsData.rowItems = state.submissionsData.rowItems.map(submissionRow =>
        submissionRow.id === updatedSubmission.id ? updatedSubmission : submissionRow,
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchSubmissionRows.pending, (state) => {
        state.submissionsData.status = ThunkStatus.LOADING;
      })
      .addCase(fetchSubmissionRows.fulfilled, (state, action) => {
        state.submissionsData.status = ThunkStatus.SUCCEEDED;
        state.submissionsData.rowItems = action.payload.submissionsPage?.content;
      })
      .addCase(fetchSubmissionRows.rejected, (state) => {
        state.submissionsData.status = ThunkStatus.FAILED;
        state.submissionsData.rowItems = [];
      });
  },
});

/* Selectors */
const selectSubmissions = state => state[submissionsSlice.name];
export const selectSubmissionsData = createSelector(selectSubmissions, ({ submissionsData }) => submissionsData);
export const selectSubmissionsStatus = createSelector(selectSubmissionsData, ({ status }) => status);
export const selectSubmissionRows = createSelector(selectSubmissionsData, ({ rowItems }) => rowItems);

/* Actions */
export const { submissionUpdated } = submissionsSlice.actions;
